// @flow
import { getAuthToken, getBidderId } from '../modules/user';
import api from '../api/conversationFolders';
import cloneDeep from 'lodash/cloneDeep';
import { createSelector } from 'reselect';
import { getDeployment } from '../modules/config';
import type { GlobalState } from '../rootReducer';

/* Action Types */
export const LOAD_CONVERSATION_FOLDERS_FAIL = 'la/domain/conversationFolders/LOAD_FAIL';
export const LOAD_CONVERSATION_FOLDERS_REQUEST = 'la/domain/conversationFolders/LOAD_REQUEST';
export const LOAD_CONVERSATION_FOLDERS_SUCCESS = 'la/domain/conversationFolders/LOAD_SUCCESS';

export const CREATE_CONVERSATION_FOLDER_FAIL = 'la/domain/conversationFolders/CREATE_FOLDER_FAIL';
export const CREATE_CONVERSATION_FOLDER_REQUEST = 'la/domain/conversationFolders/CREATE_FOLDER_REQUEST';
export const CREATE_CONVERSATION_FOLDER_SUCCESS = 'la/domain/conversationFolders/CREATE_FOLDER_SUCCESS';

/* reducer */
const DEFAULT_STATE = {
    folders: { systemFolders: [], userFolders: [] },
    loaded: false,
    loading: false,
};

export type State = {|
    ...typeof DEFAULT_STATE,
|};

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    let existing;

    switch (action.type) {
        case CREATE_CONVERSATION_FOLDER_SUCCESS:
            existing = cloneDeep(state.folders);
            const newState = {
                ...state,
                folders: {
                    ...existing,
                    userFolders: [...existing.userFolders, action.payload],
                },
            };

            return newState;
        case LOAD_CONVERSATION_FOLDERS_FAIL:
            return {
                ...state,
                loading: false,
            };
        case LOAD_CONVERSATION_FOLDERS_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case LOAD_CONVERSATION_FOLDERS_SUCCESS:
            return {
                ...state,
                folders: action.payload,
                loaded: action.meta.actionTime,
                loading: false,
            };
        default:
            return state;
    }
}

const stateSelector = (state: GlobalState) => state.conversationFolders;

const loadedSelector = createSelector(stateSelector, state => state.loaded);

const loadingSelector = createSelector(stateSelector, state => state.loading);

export const getConversationFolders = createSelector(
    stateSelector,
    state => state.folders || { systemFolders: [], userFolders: [] }
);

export const getLoadTimeForConversationFolder = loadedSelector;

export const isConversationFolderLoading = loadingSelector;

// const shouldFetch = createSelector([loadedSelector, loadingSelector], (loaded, loading) => {
//     const time = Date.now();
//     const diff = time - loaded;
//     if (diff < REDUX_STORE_TIME) return false;
//     return !loading;
// });

const loadConversationFolders = (limit: boolean) => async (dispatch, getState) => {
    try {
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);
        const bidderId = getBidderId(state);
        dispatch({
            type: LOAD_CONVERSATION_FOLDERS_REQUEST,
        });
        const response = await api.fetchConversationFolders({ authToken, bidderId, deployment, limit });
        return dispatch({
            meta: { actionTime: Date.now() },
            payload: response.payload,
            type: LOAD_CONVERSATION_FOLDERS_SUCCESS,
        });
    } catch (error) {
        return dispatch({
            error: true,
            payload: error,
            type: LOAD_CONVERSATION_FOLDERS_FAIL,
        });
    }
};

export const fetchConversationFoldersIfNeeded = (limit: boolean) => async (dispatch: Function, getState: Function) => {
    // if (shouldFetch(getState())) {
    return dispatch(loadConversationFolders(limit));
    // }
    // return Promise.resolve();
};

export const createConversationFolder = (name: string) => async (dispatch: Function, getState: Function) => {
    try {
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);
        const bidderId = getBidderId(state);
        dispatch({
            type: CREATE_CONVERSATION_FOLDER_REQUEST,
        });
        const response = await api.postNewConversationFolders({ authToken, bidderId, deployment, name });
        return dispatch({
            meta: { actionTime: Date.now() },
            payload: response.payload,
            type: CREATE_CONVERSATION_FOLDER_SUCCESS,
        });
    } catch (error) {
        return dispatch({
            error: true,
            payload: error,
            type: CREATE_CONVERSATION_FOLDER_FAIL,
        });
    }
};
